import React, { useContext } from "react";

import useTranslations from "../../../../hooks/useTranslations";
import useViewer from "../../../../hooks/useViewer";
import { BreadcrumbContext } from "../../../../hooks/useBreadcrumbs";

import { Link } from "../..";
import { PlusIcon } from "../../../icons";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Button,
  Flex,
  useBreakpointValue,
} from "@chakra-ui/react";

type HeaderProps = {
  onVisibilityChange: () => void;
};

const Header: React.FC<HeaderProps> = ({ onVisibilityChange }) => {
  const t = useTranslations();
  const { breadcrumbs } = useContext(BreadcrumbContext);
  const isBreadcrumbsHidden = useBreakpointValue({ base: true, md: false });

  const viewer = useViewer();

  return (
    <Flex
      zIndex="30"
      shrink={0}
      h="16"
      justifyContent="space-between"
      alignItems="center"
      position="relative"
      className="print:hidden"
      mx="4"
    >
      <Flex alignItems="center" justifyItems="center" grow={1}>
        <Button
          hidden={!isBreadcrumbsHidden}
          variant="ghost"
          aria-label="Open sidebar"
          onClick={onVisibilityChange}
        >
          <svg
            className="w-6 h-6"
            stroke="currentColor"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 6h16M4 12h16M4 18h7"
            />
          </svg>
        </Button>
        <Breadcrumb hidden={isBreadcrumbsHidden} id="breadcrumbs">
          {breadcrumbs.map(({ to, text }) =>
            !text ? null : (
              <BreadcrumbItem key={to}>
                <BreadcrumbLink as={Link} to={to}>
                  {text}
                </BreadcrumbLink>
              </BreadcrumbItem>
            )
          )}
        </Breadcrumb>
      </Flex>
      {viewer.isCapableOfInsertingReviews && (
        <div className="flex items-center">
          <Link
            variant="button"
            to="/reviews/new"
            className="flex items-center"
          >
            {t("header.createReview")}
            <PlusIcon className="w-4 h-4 ml-1" />
          </Link>
        </div>
      )}
    </Flex>
  );
};

export default Header;
